import { config } from './config'
import { Title, SubTitle, Wrapper, List, ListItem } from './styles'

const { projectScopeSections, text, title } = config

export function ProjectScope() {
  return (
    <Wrapper>
      <Title>{title}</Title>
      <SubTitle>{text}</SubTitle>
      {projectScopeSections && (
        <List>
          {projectScopeSections.map(({ id, text }) => (
            <ListItem key={id}>{text}</ListItem>
          ))}
        </List>
      )}
    </Wrapper>
  )
}
